/* Paths */
import { reportPaths } from "common/data/routePaths"
import { lazy } from "react"

// Claim V2 Report
const ClaimReportV2 = lazy(() =>
  import("pages/Reports/ReinsurerReports/ClaimReportV2")
)
// loss ratio v5
const LossRatioV5 = lazy(() =>
  import("pages/Reports/ReinsurerReports/LossRatioV5")
)
const { claimReportV2, lossRatioV5 } = reportPaths

export const ReinsurerReportsRoutes = [
  // Claim Report v2
  { path: claimReportV2, component: ClaimReportV2 },

  // loss ratio report v5
  { path: lossRatioV5, component: LossRatioV5 },
]
